// Mark JS as active — enables CSS [data-reveal] base states (prevents invisible-without-JS)
document.documentElement.classList.add('js-ready');

// ── Hero parallax ────────────────────────────────────────────────
(function () {
  const media = document.querySelector('.hero__media img, .hero__media video');
  if (!media) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  media.style.willChange = 'transform';
  media.style.transform  = 'scale(1.10)';
  const onScroll = () => {
    if (window.scrollY > window.innerHeight) return;
    media.style.transform = `scale(1.10) translateY(${window.scrollY * 0.22}px)`;
  };
  window.addEventListener('scroll', onScroll, { passive: true });
})();

// ── Word-split reveal for [data-words] ──────────────────────────
(function () {
  document.querySelectorAll('[data-words]').forEach(el => {
    const words = el.textContent.trim().split(/\s+/);
    el.innerHTML = words.map((w, i) =>
      `<span class="wr"><span class="wr__w" style="animation-delay:${(0.5 + i * 0.10).toFixed(2)}s">${w}</span></span>`
    ).join(' ');
  });
})();

// ── Scroll reveal for [data-reveal] ─────────────────────────────
(function () {
  const items = Array.from(document.querySelectorAll('[data-reveal]'));
  if (!items.length) return;

  function markVisible(el) { el.classList.add('in-view'); }

  // Elements already visible on load → mark immediately (above-fold content)
  items.forEach(el => {
    if (el.getBoundingClientRect().top < window.innerHeight + 80) markVisible(el);
  });

  const io = new IntersectionObserver((entries) => {
    entries.forEach(({ target, isIntersecting }) => {
      if (!isIntersecting) return;
      markVisible(target);
      io.unobserve(target);
    });
  }, { threshold: 0.07, rootMargin: '0px 0px -10px 0px' });

  items.forEach(el => {
    if (!el.classList.contains('in-view')) io.observe(el);
  });

  // Scroll fallback — catches fast scrollers where IO misses
  const check = () => {
    document.querySelectorAll('[data-reveal]:not(.in-view)').forEach(el => {
      if (el.getBoundingClientRect().top < window.innerHeight + 80) markVisible(el);
    });
  };
  window.addEventListener('scroll', check, { passive: true });
  setTimeout(check, 300);
})();

// ── Legacy .reveal system (kept for compatibility) ───────────────
function setupReveal() {
  const checkReveal = () => {
    document.querySelectorAll('.reveal:not(.visible)').forEach(el => {
      const r = el.getBoundingClientRect();
      if (r.top < window.innerHeight + 80 && r.bottom > 0) el.classList.add('visible');
    });
  };

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('visible');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.04, rootMargin: '0px 0px 80px 0px' });

  document.querySelectorAll('.reveal').forEach(el => {
    const rect = el.getBoundingClientRect();
    if (rect.top < window.innerHeight && rect.bottom > 0) {
      el.classList.add('visible');
    } else {
      observer.observe(el);
    }
  });

  window.addEventListener('scroll', checkReveal, { passive: true });
  setTimeout(checkReveal, 150);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', setupReveal);
} else {
  requestAnimationFrame(setupReveal);
}

// ── Header scroll state ──────────────────────────────────────────
const header = document.getElementById('site-header');
if (header) {
  const onScroll = () => header.classList.toggle('scrolled', window.scrollY > 50);
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();
}

// ── Mobile menu ──────────────────────────────────────────────────
const menuBtn = document.getElementById('mobile-menu-btn');
const mobileNav = document.getElementById('mobile-nav');
const closeBtn = document.getElementById('mobile-nav-close');

function openMenu() {
  mobileNav.classList.add('open');
  menuBtn.classList.add('open');
  menuBtn.setAttribute('aria-expanded', 'true');
  document.body.style.overflow = 'hidden';
}

function closeMenu() {
  mobileNav.classList.remove('open');
  menuBtn.classList.remove('open');
  menuBtn.setAttribute('aria-expanded', 'false');
  document.body.style.overflow = '';
}

if (menuBtn) menuBtn.addEventListener('click', openMenu);
if (closeBtn) closeBtn.addEventListener('click', closeMenu);

if (mobileNav) {
  mobileNav.querySelectorAll('a').forEach(a => a.addEventListener('click', closeMenu));
}

document.addEventListener('keydown', e => { if (e.key === 'Escape') closeMenu(); });
